
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/office-action",
      function () {
        return require("private-next-pages/office-action.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/office-action"])
      });
    }
  